import {useMutation} from "@apollo/client";
import {flushSync} from "react-dom";
import toast from "react-hot-toast";
import {FiSave} from "react-icons/fi";
import {useNavigate} from "react-router";

import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {GQL_USER_CONTEXT} from "@/lib/queries/accounts.ts";
import {
  GQL_DASHBOARD_DEFINITION,
  GQL_DASHBOARD_SAVE,
  GQL_DASHBOARD_STATS,
  UpdateDashboardDefinitionResult,
} from "@/lib/queries/website.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {DashboardDefinition} from "@/lib/types/website.ts";
import {dashboardDefinitionToInput} from "@/pages/dashboard/display/dashboardUtils.ts";

interface DashboardSaveActionProps {
  unsaved: boolean;
  dashboardDef: DashboardDefinition;
  onBeforeNavigate: () => void;
}

export const DashboardSaveAction = ({unsaved, dashboardDef, onBeforeNavigate}: DashboardSaveActionProps) => {
  const [saveDashboard] = useMutation<UpdateDashboardDefinitionResult>(GQL_DASHBOARD_SAVE, {
    refetchQueries: [GQL_DASHBOARD_DEFINITION, GQL_DASHBOARD_STATS, GQL_USER_CONTEXT],
  });
  const navigate = useNavigate();

  const doSave = async () => {
    const response = await saveDashboard({
      variables: {
        dashboard_def: dashboardDefinitionToInput(dashboardDef),
      },
    });

    if (response.data?.response?.status === ResponseStatus.SUCCESS) {
      toast.success("Dashboard saved");
      flushSync(() => {
        onBeforeNavigate();
      });
      navigate(`/dashboard/${response.data?.response?.data.id}`);
    } else {
      console.error(response);
    }
  };

  return (
    <>
      {unsaved && (
        <IconButton
          data-testid="saveDashboard"
          icon={FiSave}
          size="large"
          title="Save changes to this dashboard"
          onClick={doSave}
        />
      )}
    </>
  );
};
